import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import server_Error from "../../images/server_Error.jpeg";

const ServerErrorDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Server Error</DialogTitle>
      <DialogContent>
        <img src={server_Error} alt="Server Error" style={{ width: "100%", marginBottom: 10 }} />
        <DialogContentText>
          For checking server, click on "Mark For Review" or "Save & Next" buttons. 
          If you do not get this popup message, it means your server is back stronger.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{
          onClose()
          window.location.reload() 
        }}>Try Again</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServerErrorDialog;